// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// const firebaseConfig = {
//     apiKey: "AIzaSyAiq5f4EtozrayaaebQSq3YbZ-TTLMXnPs",
//     authDomain: "the-grays-71cc9.firebaseapp.com",
//     projectId: "the-grays-71cc9",
//     storageBucket: "the-grays-71cc9.appspot.com",
//     messagingSenderId: "913011906370",
//     appId: "1:913011906370:web:522dfbdd3382c2c449dadb"
// };

// Firebase : The Grays V2
// const firebaseConfig = {
//     apiKey: "AIzaSyA_9lOv6CHQSQfm0Py160ijqzVHWVK-u6c",
//     authDomain: "the-grays-v2.firebaseapp.com",
//     projectId: "the-grays-v2",
//     storageBucket: "the-grays-v2.appspot.com",
//     messagingSenderId: "214428977115",
//     appId: "1:214428977115:web:9315be8d86deb2287789fe"
// };

// const firebaseConfig = {
//     apiKey: "AIzaSyBUrZ0eHne5nJyalviOZPWLY9FgftlRPq4",
//     authDomain: "tgc-v4.firebaseapp.com",
//     projectId: "tgc-v4",
//     storageBucket: "tgc-v4.appspot.com",
//     messagingSenderId: "425889946192",
//     appId: "1:425889946192:web:86c42cf410371df5508f55"
// };

const firebaseConfig = {
    apiKey: "AIzaSyC2erwRb6PG19LVN1EqAsIvW5RJ639H2Sc",
    authDomain: "thegraycurrency.firebaseapp.com",
    projectId: "thegraycurrency",
    storageBucket: "thegraycurrency.appspot.com",
    messagingSenderId: "835587571888",
    appId: "1:835587571888:web:dba8e31c369832f3a5bb75"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)
// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app)
const storage = getStorage(app)

export { app, db, storage }